import { render, staticRenderFns } from "./salarymodal.vue?vue&type=template&id=de037c26"
import script from "./salarymodal.vue?vue&type=script&lang=js"
export * from "./salarymodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports